import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueQrcodeReader from "vue-qrcode-reader";
import VueGtag from "vue-gtag";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
//import './registerServiceWorker'
//import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VueImg from 'v-img';

import { VueMaskDirective } from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueViewer);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBsZ7SS-Nc4AaW5IaLaEU3iAd30C0CFoZQ', // Reemplaza con tu clave API
    libraries: 'places', // Puedes añadir otras bibliotecas según tus necesidades
  },
});

import money from 'v-money'

import {formatoFechaSpanish, formatoFecha, formatoFechaHoras, formatoNumero,quitarformatoNumero,esNulo,diferenciaMenorAXDias} from './plugins/formatos.js'
import {numerosALetras} from './plugins/numeroLetras.js'
const hostname = window.location.hostname;
const entorno=hostname=="cobranza.megapps.com.bo"?"P":hostname=="testcobranzas.megapps.com.bo"?"T":"D";
Vue.use(money, {precision: 4})
Vue.prototype.$formatoFechaSpanish = formatoFechaSpanish;
Vue.prototype.$formatoFecha = formatoFecha;
Vue.prototype.$formatoFechaHoras = formatoFechaHoras;
Vue.prototype.$numerosALetras = numerosALetras;
Vue.prototype.$formatoNumero = formatoNumero;
Vue.prototype.$quitarformatoNumero = quitarformatoNumero;
Vue.prototype.$diferenciaMenorAXDias = diferenciaMenorAXDias;
Vue.prototype.$esNulo = esNulo;
Vue.prototype.$ENTORNO = entorno;

Vue.directive('mask', VueMaskDirective);

Vue.use(VueImg);
Vue.use(VueQrcodeReader);
Vue.use(VueGtag, {
  config: { 
    //id: 'UA-11111111-1'  //cambiar este codigo posteriormente
    //id: 'G-C0DS104EEC'
    id: 'G-BT5733VG9J'
  } 
});
window._ = require('lodash');
Vue.config.productionTip = false

const baseURLs = {
  'cobranza.megapps.com.bo': 'https://cobranza.megapps.com.bo/',  
  'testcobranzas.megapps.com.bo': 'https://testcobranzas.megapps.com.bo/',  
  'localhost': 'https://localhost:44340/'
};


axios.defaults.baseURL = baseURLs[hostname] || 'https://localhost:44340/';

// Configurar interceptor de Axios para agregar token a las peticiones
axios.interceptors.request.use(
  (config) => {
    const token = store.state.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta para manejar errores de autenticación
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expirado o inválido
      store.dispatch('salir');
    }
    return Promise.reject(error);
  }
);



new Vue({
  router,
  store,
  
  vuetify,
  render: h => h(App)
}).$mount('#app')